import { PageRequest } from "@/components/tasks-kanban/adapter";

export class GetListTaskTypeRequest {
  NamespaceId!: string;
  Search!: string;
  Page!: PageRequest;
  constructor(obj?: Partial<GetListTaskTypeRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
